var map = {
	"./StoryUiStrings": [
		18126,
		8126
	],
	"./StoryUiStrings.ts": [
		18126,
		8126
	],
	"./StoryUiStringsEnglish": [
		62993,
		2993
	],
	"./StoryUiStringsEnglish.ts": [
		62993,
		2993
	],
	"./StoryUiStringsSpanish": [
		8324,
		8324
	],
	"./StoryUiStringsSpanish.ts": [
		8324,
		8324
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40631;
module.exports = webpackAsyncContext;